<template>
  <div>
    <template v-for="(child,index) in menuData">
      <template v-if="(child.children||[]).length > 0">
        <el-submenu :key='index' :index="child.path">
          <template slot="title">
            <i :class="child.iconCls?child.iconCls:[fa,fa-file]"></i>
            <span slot="title">{{ child.name }}</span>
          </template>
          <menu-tree :menuData="child.children||[]"></menu-tree>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item :key='index' :index="child.path" v-if="!child.hidden">
          <i :class="child.iconCls?child.iconCls:[fa,fa-file]"></i>
          <span slot="title">{{ child.name }}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "menuTree",
  props: ["menuData"]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/aside/menuTree.vue